module.exports = __webpack_public_path__ + "static/media/gotmyer_esp.dd3f9734.mp4";